// extracted by mini-css-extract-plugin
export default {"root":"yU1e7q"};